import { memo } from 'react'
import styled from 'styled-components'
import { isEmpty, length } from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { colors, fontWeights, breakpoints } from '@/styles'

const Wrapper = styled.div``

const TableTitle = styled.p`
  font-weight: ${fontWeights.medium};
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey16};
  margin: 0 0 20px 0;
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
    padding: 0 12px;
  }
`

const DataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns}, 1fr);
  grid-gap: 16px 0;
  ${props =>
    props.showBorder &&
    `

    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.grey88};
  `}

  @media only screen and (max-width: ${breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    grid-gap: 0;
    > :not(:last-child) {
      border-bottom: 1px solid ${colors.grey88};
    }
  }
`

const DisplayTable = ({
  title,
  data,
  columns = 1,
  emptyComponent,
  subColumns,
  subTitle,
  showBorder = false,
  CustomDataContainer
}) => {
  const noData = isEmpty(data)
  const renderEmpty = emptyComponent ? emptyComponent : null
  const renderColumns = noData ? 1 : columns
  const DataContainerComponent = CustomDataContainer ? CustomDataContainer : DataContainer
  return (
    <Wrapper key={uuidv4()}>
      {!!title && <TableTitle>{title}</TableTitle>}

      {!!subTitle && subTitle}
      <DataContainerComponent columns={renderColumns} showBorder={showBorder}>
        {noData
          ? renderEmpty
          : data?.map((item, index) => {
              const isNested = Array.isArray(item.items)

              return isNested ? (
                <DisplayTable
                  key={uuidv4()}
                  columns={subColumns}
                  subTitle={item.subTitle}
                  data={item.items}
                  showBorder={length(data) > 1 && index !== length(data) - 1}
                />
              ) : (
                item.cell
              )
            })}
      </DataContainerComponent>
    </Wrapper>
  )
}

export default memo(DisplayTable)
